<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<car-sale-search
						ref="carSaleSearch"
						:scrId="scrId"
						:pStartDt="pStartDt"
						:pEndDt="pEndDt"
						:pState1="pState1"
						:pState2="pState2"
						:pState3="pState3"
						:pState4="pState4"
						:pState5="pState5"
						:pState6="pState6"
						:pState10="pState10"
						
					/>
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-17">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<car-sale-table ref="table" @PopupOpen="PopupOpen" @Refresh="Refresh" :scrId="scrId" />
					<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
			<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
		</div>
	</div>
</template>

<script>
import CarSaleSearch from './Search/CarSaleSearch.vue';
import CarSaleTable from './Table/CarSaleTable.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' },
		pEndDt: { type: String, default: '' },
		pState1: { type: String, default: '' },
		pState2: { type: String, default: '' },
		pState3: { type: String, default: '' },
		pState4: { type: String, default: '' },
		pState5: { type: String, default: '' },
		pState6: { type: String, default: '' },
		pState10: { type: String, default: '' }
	},
	components: { CarSaleSearch, CarSaleTable, ExcelUploadModal },
	methods: {
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.carSaleSearch.searchList();
		},
		PopupOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	}
};
</script>

<style></style>
